import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Box, Text, ButtonProps } from "grommet";
import React from "react";
import StyledModal from "../components/StyledModel";
import TeamMemberRole from "../teams/TeamMemberRole";
import { TeamRow } from "../teams/TeamsManagement";
import { AliasViewModel, deleteAlias } from "./AliasStore";

const trash = <FontAwesomeIcon icon={["fad", "trash"]} size="sm"></FontAwesomeIcon>;

const DeleteAlias = ({ alias, onCancel, onDelete }: { alias: AliasViewModel; onCancel: Function; onDelete: Function }) => {
    const [deleteErrors, setDeleteErrors] = React.useState([] as string[]);

    const confirmDelete = () => {
        deleteAlias(alias.id).then((res) => {
            if (!res.success) {
                setDeleteErrors(res.errors);
            } else {
                onDelete();
            }
        });
    };

    return (
        <>
            <Text>Are you sure you want to delete {AliasViewModel.displayName(alias)}?</Text>
            {alias.teams && alias.teams.length > 0 && (
                <>
                    <Text size="small">This will also remove them from the following teams</Text>
                    <Box pad={"small"}>
                        {alias.teams?.map((team) => (
                            <TeamRow team={team.team} key={team.id}>
                                <TeamMemberRole role={team.roleName}></TeamMemberRole>
                            </TeamRow>
                        ))}
                    </Box>
                </>
            )}
            <Box direction="row" gap="small" justify="end">
                <Button onClick={() => onCancel()} label="Cancel"></Button>
                <Button primary onClick={confirmDelete} icon={trash} label="Delete" color="status-critical"></Button>
            </Box>
            {deleteErrors.length > 0 && (
                <Box pad={{ top: "small" }}>
                    {deleteErrors.map((e, i) => (
                        <Text color="status-critical" key={i}>
                            {e}
                        </Text>
                    ))}
                </Box>
            )}
        </>
    );
};

export const DeleteAliasButton = ({ size, alias, onDelete }: { size?: ButtonProps["size"]; alias: AliasViewModel; onDelete: Function }) => {
    const [showAliasDeleteModal, setShowAliasDeleteModal] = React.useState(false);
    return (
        <>
            <Button onClick={() => setShowAliasDeleteModal(true)} icon={trash} label="Delete" color="status-critical" size={size}></Button>
            <StyledModal isOpen={showAliasDeleteModal} setIsOpen={() => setShowAliasDeleteModal(!showAliasDeleteModal)}>
                <DeleteAlias
                    alias={alias}
                    onCancel={() => setShowAliasDeleteModal(false)}
                    onDelete={() => {
                        onDelete();
                        setShowAliasDeleteModal(false);
                    }}
                ></DeleteAlias>
            </StyledModal>
        </>
    );
};

export default DeleteAlias;
